import { render, staticRenderFns } from "./TobaccoShipment.vue?vue&type=template&id=f0a660c6&scoped=true&"
import script from "./TobaccoShipment.vue?vue&type=script&lang=js&"
export * from "./TobaccoShipment.vue?vue&type=script&lang=js&"
import style0 from "./TobaccoShipment.vue?vue&type=style&index=0&id=f0a660c6&prod&lang=css&"
import style1 from "./TobaccoShipment.vue?vue&type=style&index=1&id=f0a660c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a660c6",
  null
  
)

export default component.exports